import { useLingui } from '@lingui/react/macro';

import { EmptyState } from '@/components/EmptyState';

import { IllustrationInvoicesEmptyState } from '../../Invoices/components/IllustrationInvoicesEmptyState';

export const InvoiceLinesEmptyState = () => {
  const { t } = useLingui();

  return (
    <EmptyState
      subtitle={t({
        id: 'accounting.invoice-lines.empty-state.subtitle',
        message: 'No services to display',
      })}
      illustration={<IllustrationInvoicesEmptyState />}
    />
  );
};
